import { ClearableTextField } from '@app/components/form/ClearableTextField';
import { ComponentProps } from 'react';
import { defineMessage, useIntl } from 'react-intl';

export const advertiserFieldMessage = defineMessage({
  id: 'audit.props.advertiser',
  defaultMessage: 'Anunciante',
});

type AdvertiserFieldProps = Omit<ComponentProps<typeof ClearableTextField>, 'name' | 'label'> & {
  name?: string;
  label?: string;
};

/**
 * Shared Formik text field for filtering by advertiser.
 */
export function AdvertiserField({
  name = 'advertiser',
  submitOnClear = true,
  label,
  ...props
}: AdvertiserFieldProps) {
  const { $t } = useIntl();

  return (
    <ClearableTextField
      name={name}
      submitOnClear={submitOnClear}
      label={label ?? $t(advertiserFieldMessage)}
      {...props}
    />
  );
}
